import {HttpServices} from "../Helpers";

export const GetAllItemsByHelperDynamic = async (apiPath, {for_campaign}) => {
  const queryList = [];
  if (for_campaign) queryList.push(`for_campaign=${for_campaign}`);

  const result = await HttpServices.get(`${apiPath}?${queryList.join("&")}`)
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
